<template>
  <div class="custom-dialog">
    <custom-modal :active="promptStatus"
                  :fixed-height="false"
                  @close="handleCloseDialog">
      <template #header>
        <div class="prompt-header custom-dialog-header-wrapper">
          <vs-row>
            <vs-spacer/>

            <vs-col class="dialog-header">
<!--              <div v-if="getIcon" class="custom-dialog-icon" :class="[`u-bg-${accessColor}`]">
                <custom-icon :icon="getIcon" icon-weight="solid" :color="accessColor" height="2.4rem" width="2.4rem" />
              </div>-->
              <slot name="header">
                <span v-html="title">
                </span>
              </slot>
            </vs-col>

            <vs-spacer/>
          </vs-row>
        </div>
      </template>
      <template #content>
        <div class="prompt-content custom-dialog-body-wrapper">
          <slot>
            <vs-col class="custom-dialog-body">
              <slot name="body">
              <span v-html="body">
  <!--            {{ body }}-->
              </span>
              </slot>
            </vs-col>
          </slot>

          <!--<vs-divider v-if="showButtons"
                      class="my-3"/>-->

          <div v-if="showButtons" class="dialog-action-box">
            <slot name="actions">
              <div v-if="hasCancel" class="dialog-action-wrapper" :class="[`w-1/${multiActions.length > 0 ? multiActions.length + 1 : 2}`]">
                <vs-button class="w-full dialog-action"
                           type="border"
                           color="rgb(153,153,153)"
                           @click="$emit('close'), promptStatus = false">
                  {{ cancelText || $t('components.customDialog.cancel') }}
                </vs-button>
              </div>

              <template v-if="multiActions.length > 0">
                <template v-for="(action, actionKey) in multiActions">
                  <div :key="actionKey" class="dialog-action-wrapper" :class="[{[`w-1/${multiActions.length + 1}`]: hasCancel}]">
                    <vs-button class="w-full dialog-action"
                               :color="action.color"
                               @click="$emit(action.event), promptStatus = false">
                      {{ action.label || $t('components.customDialog.confirm') }}
                    </vs-button>
                  </div>
                </template>
              </template>
              <div v-else class="dialog-action-wrapper" :class="[{'w-1/2': hasCancel}]">
                <vs-button class="w-full dialog-action"
                           :color="accessColor"
                           @click="$emit('accept'), promptStatus = false">
                  {{ acceptText || $t('components.customDialog.confirm') }}
                </vs-button>
              </div>
            </slot>
          </div>
        </div>
      </template>
    </custom-modal>
  </div>
</template>

<script>
import CustomModal from '@/components/modal/customModal.vue'
import CustomIcon from "../icon/customIcon.vue";

export default {
  name: 'customDialog',
  components: {CustomIcon, CustomModal},
  props: {
    title: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: ''
    },
    closed: {
      type: Boolean,
      default: true
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    hasCancel: {
      type: Boolean,
      default: true
    },
    accessColor: {
      type: String,
      default: 'danger',
      validator (value) {
        return ['success', 'danger', 'warning', 'dark', 'primary'].includes(value)
      }
    },
    acceptText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    multiActions: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      promptStatus: false
    }
  },
  computed: {
    getIcon () {
      switch (this.accessColor) {
        case 'danger':
          return 'triangle-exclamation-icon'
          break
      }
    }
  },
  methods: {
    showDialog () {
      this.promptStatus = true
    },
    handleCloseDialog () {
      if (this.closed) {
        this.$emit('close')
        this.promptStatus = false
      } else {
        this.promptStatus = true
      }
    }
  }
}
</script>

<style lang="scss">
.custom-dialog-header-wrapper {
  padding: 2.4rem 2.4rem 0.8rem !important;

  .dialog-header {
    font-size: 1.8rem;
    font-weight: 600;

    .custom-dialog-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 4.4rem;
      width: 4.4rem;
      margin-bottom: 1.6rem;
      border-radius: 50%;
    }
  }
}

.custom-dialog-body-wrapper {
  padding: 0 2.4rem 2.4rem !important;

  .custom-dialog-body {
    text-align: justify;
    margin-bottom: 2.4rem;
  }
}

.dialog-action-box {
  display: flex;
  align-items: stretch;
  gap: 1.2rem;

  .dialog-action-wrapper {
    cursor: pointer;

    .dialog-action {
      height: 100%;
      padding: 0.75rem !important;
      font-weight: 500;
      border-radius: 0.5rem;
    }
  }
}
</style>
